export const BANNER_SIZE = {
  leaderBoard: {
    width: '728px',
    height: '90px',
  },
  mobileBanner: {
    width: '300px',
    height: '50px',
  },
  mediumRectangle: {
    width: '300px',
    height: '136px',
  },
};
